import _ from 'lodash';

export default class Form {
  constructor(id) {
    this.id = _.defaultTo(id, null);
    this.getUrl = `https://api.umbraco.io/forms/${this.id}/`;
    this.postUrl = `https://api.umbraco.io/forms/${this.id}/entries/`;
    this.headers = {
      'Content-Type': 'application/json',
      'umb-project-alias': _.defaultTo(process.env.GATSBY_FORMS_UMBRACO_ENVIRONMENT, 'dev-dwtc-new'),
      'Api-Key': _.defaultTo(process.env.GATSBY_UMBRACO_FORMS_API_KEY, ''),
    };
  }
  

  async get() {
    try {
      if (_.isNull(this.id)) throw new Error('Form id cannot be empty');

      const method = 'GET';
      const headers = this.headers;
      const url = this.getUrl;

      const response = await fetch(url, { method, headers });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      const fields = _.get(data, 'pages[0].fieldsets[0].columns[0].fields', []);
      const modded = _.omit(data, ['pages']);
      _.set(modded, 'fields', fields);
      // console.log(modded);

      return modded;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async post(data) {
    try {
      if (_.isNull(this.id)) throw new Error('Form id cannot be empty');
      if (_.isEmpty(data)) throw new Error('Data to post cannot be empty');

      const method = 'POST';
      const headers = this.headers;
      const url = this.postUrl;
      const body = JSON.stringify(data);

      const response = await fetch(url, { method, headers, body });

      if (!response.ok) throw new Error('Network response was not ok');

      return await response.json();
    } catch (err) {
      console.log(err);
    }
  }
}
